// 识别是否为普通可打印字符
export const getPrintableChar = (event) => {
  if (event.ctrlKey || event.altKey || event.metaKey) return null;
  return event.key.length === 1 ? event.key.toUpperCase() : null;
};

// 进度条帧
const PROGRESS_FRAMES = [' [=    ]', ' [==   ]', ' [===  ]', ' [==== ]', ' [=====]'];
export const getProgressBarFrame = (tick) => PROGRESS_FRAMES[tick % PROGRESS_FRAMES.length];

export const formatMsg = (msg) => (msg ? msg.toString().toUpperCase() : '');

export const TERMINAL_SESSION_ID = 'TERMINAL_SESSION_ID';

export const SHORTCUTS = [
  { key: 'Ctrl + Enter', desc: 'EXECUTE COMMAND' },
  { key: 'Ctrl + S', desc: 'CLEAR SCREEN' },
  { key: 'Ctrl + H', desc: 'SHOW HELP' },
  { key: 'Ctrl + C', desc: 'COPY' },
  { key: 'Ctrl + V', desc: 'PASTE' },
  { key: 'Ctrl + O', desc: 'SHOW HISTORY' },
  { key: 'Alt + Up/Down', desc: 'SWITCH HISTORY' },
];
